const indexablePaths = [
  "/",
  "/authentication/login",
  "/authentication/password-recovery",
  "/authentication/resend-invite",
];

function normalizePath(path: string) {
  if (path === "/") {
    return path;
  }

  return path.endsWith("/") ? path.slice(0, -1) : path;
}

export function shouldIndexPath(path: string) {
  return indexablePaths.includes(normalizePath(path));
}
